<template>
  <b-container>
    <b-modal
      size="lg"
      ref="openModal"
      class="filterDateModal"
      scrollable
      title="Criar trajeto"
      @ok="modalOk(model)"
    >
      <div v-if="model">
        <div v-if="optionsState && optionsState != null">
          <!-- OriginStateId -->
          <b-form-group
            :label="$t('tracking.cargo.originState')"
            label-for="OriginStateId"
          >
            <state-dropdown
              id="OriginStateId"
              :states="optionsState"
              :state-id="parseInt(model.originStateId)"
              :changeId.sync="model.originStateId"
              :changeAbrev.sync="model.originStateAbrev"
            >
            </state-dropdown>
          </b-form-group>

          <!-- OriginCityId -->
          <b-form-group
            :label="$t('tracking.cargo.originCity')"
            label-for="OriginCityId"
          >
            <city-dropdown
              id="OriginCityId"
              :state-id="parseInt(model.originStateId)"
              :city-id="model.originCityId"
              :changeData.sync="model.originCityId"
              :changeName.sync="model.originCityName"
            >
            </city-dropdown>
          </b-form-group>

          <!-- DestinationStateId -->
          <b-form-group
            :label="$t('tracking.cargo.destinationState')"
            label-for="DestinationStateId"
          >
            <state-dropdown
              id="DestinationStateId"
              :states="optionsState"
              :state-id="parseInt(model.destinationStateId)"
              :changeId.sync="model.destinationStateId"
              :changeAbrev.sync="model.destinationStateAbrev"
            >
            </state-dropdown>
          </b-form-group>
          <!-- DestinationCityId -->
          <b-form-group
            :label="$t('tracking.cargo.destinationCity')"
            label-for="DestinationCityId"
          >
            <city-dropdown
              id="DestinationCityId"
              :state-id="parseInt(model.destinationStateId)"
              :city-id="model.destinationCityId"
              :changeData.sync="model.destinationCityId"
              :changeName.sync="model.destinationCityName"
            >
            </city-dropdown>
          </b-form-group>
        </div>

        <!-- NfeNumber -->
        <b-form-group label="Nf-e" label-for="NfeNumber">
          <b-form-input
            id="NfeNumber"
            type="text"
            placeholder="Nf-e"
            v-model="model.nfeNumber"
          />
        </b-form-group>

        <!-- CteNumber -->
        <b-form-group label="CT-e" label-for="CteNumber">
          <b-form-input
            id="CteNumber"
            type="text"
            placeholder="CT-e"
            v-model="model.cteNumber"
          />
        </b-form-group>
        <!-- ManifestNumber -->
        <b-form-group label="Manifesto" label-for="ManifestNumber">
          <b-form-input
            id="ManifestNumber"
            type="text"
            placeholder="Manifesto"
            v-model="model.manifestNumber"
          />
        </b-form-group>
        <!-- CiotNumber -->
        <b-form-group label="CIOT" label-for="CiotNumber">
          <b-form-input
            id="CiotNumber"
            type="text"
            placeholder="CIOT"
            v-model="model.ciotNumber"
          />
        </b-form-group>
        <!-- freightContract -->
        <b-form-group label="Contrato de frete" label-for="FreightContract">
          <b-form-input
            id="FreightContract"
            type="text"
            placeholder="Contrato de frete"
            v-model="model.freightContract"
          />
        </b-form-group>
        <!-- valor frete -->
        <b-form-group label="Valor do frete" label-for="FreightCost">
          <base-input-numeric
            id="FreightCost"
            placeholder="Valor do frete"
            :value.sync="model.freightCost"
          >
          </base-input-numeric>
        </b-form-group>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button variant="green" @click="ok()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <h3>Trajetos</h3>
    <b-row>
      <b-col>
        <b-button class="newPath" @click="modalOpen" size="sm">
          Adicionar novo trajeto
        </b-button>
      </b-col>
    </b-row>
    <b-table
      ref="table"
      :busy.sync="isBusy"
      :items="fillActiveList"
      :fields="fields"
    >
      <template v-slot:cell(actions)="data">
        <!-- {{ data.item }} -->
        <div>
          <cargo-path-modal-edit
            :cargo-path="data.item"
            :optionsState="optionsState"
            :hasError="hasErros"
            :readonly="readonly"
            @refresh="confirmEdit"
          >
          </cargo-path-modal-edit>
          <b-button
            class="deletePath"
            variant="danger"
            size="sm"
            @click="deletePath(data)"
          >
            x
          </b-button>
        </div>
      </template>
      <template v-slot:cell(status)="data">
        <span class="icon" v-if="getStatus(data.item)"
          ><i class="tim-icons icon-check-2"></i
        ></span>
        <span class="icon" v-if="getStatus(data.item) == false"
          ><i class="tim-icons icon-simple-remove"></i
        ></span>
      </template>
      <template v-slot:cell(delivered)="data">
        <div class="delivered">
          <!-- {{data}} -->
          <span class="icon" v-if="data.item.delivered"
            ><i class="tim-icons icon-check-2"></i
          ></span>
          <span class="icon" v-if="!data.item.delivered"
            ><i class="tim-icons icon-simple-remove"></i
          ></span>
        </div>
      </template>
    </b-table>
    <div>
      <!-- {{ path }} -->
      <!-- {{ items }} -->
      <!-- {{tableRows}} -->
      <!-- {{ carga }} -->
      <!-- {{ readonly }} -->
    </div>
  </b-container>
</template>
  <script>
export default {
  name: "CargoPath",
  components: {
    CityDropdown: () => import("@/components_rms/System/city/CityDropdown.vue"),
    StateDropdown: () =>
      import("@/components_rms/System/state/StateDropdown.vue"),
    CargoPathModalEdit: () =>
      import("@/components_rms/tracking/cargo/CargoPathModalEdit.vue"),
    BaseInputNumeric: () => import("../../base/BaseInputNumeric.vue"),
  },
  props: {
    items: Array,
    readonly: Boolean,
    modelstate: Object,
    carga: Object,
  },
  data() {
    return {
      path: true,
      optionsState: null,
      tableRows: [],
      error: [],
      model: [],
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          tdClass: "tableActions",
        },
        {
          key: "status",
          filterKey: "status",
          sortable: false,
          label: "status",
          tdClass: "nowrap",
        },
        {
          key: "sequenceNumber",
          filterKey: "sequenceNumber",
          sortable: false,
          label: "Nº Trajeto",
          tdClass: "nowrap",
        },
        {
          key: "originCityName",
          filterKey: "originCityName",
          sortable: false,
          label: "Cidade Origiem",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "originStateAbrev",
          filterKey: "originStateAbrev",
          sortable: false,
          label: "Estado Origem",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "destinationCityName",
          filterKey: "destinationCityName",
          sortable: false,
          label: "Cidade destino",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "destinationStateAbrev",
          filterKey: "destinationStateAbrev",
          sortable: false,
          label: "Estado Destino",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "nfeNumber",
          filterKey: "nfeNumber",
          sortable: false,
          label: "NF-e",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "cteNumber",
          filterKey: "cteNumber",
          sortable: false,
          label: "CT-e",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "manifestNumber",
          filterKey: "manifestNumber",
          sortable: false,
          label: "Manifesto",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "ciotNumber",
          filterKey: "ciotNumber",
          sortable: false,
          label: "CIOT",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "freightContract",
          filterKey: "freightContract",
          sortable: false,
          label: "Número contrato",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "freightCost",
          filterKey: "freightCost",
          sortable: false,
          label: "Valor do frete",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "delivered",
          filterKey: "delivered",
          sortable: false,
          label: "Entregue",
          tdClass: "actions",
        },
      ],
      isBusy: false,
    };
  },
  created() {
    this.loadStates();
    this.loadTableRows();
  },
  computed: {
    hasErros() {
      if (!this.modelstate) return false;
      if (this.modelstate.length == 0) return false;

      let count = 0;
      for (let variable in this.modelstate) {
        count++;
      }
      if (count == 0) return false;

      return true;
    },
    fillActiveList() {
      let pathsAtivos = [];
      for (let path of this.tableRows.sort()) {
        // console.log("path:", path);
        if (path.active) {
          pathsAtivos.push(path);
        }
      }
      return pathsAtivos;
    },
  },
  methods: {
    confirmEdit(path) {
      for (let item of this.getSortedList(this.items)) {
        if (item.active == true) {
          if (
            !item.sequenceNumber ||
            item.sequenceNumber == null ||
            item.sequenceNumber <= 0
          ) {
            item.sequenceNumber = this.getNextSequenceNumber(this.items);
          }
        }
      }
      this.$forceUpdate();
    },
    modalOpen() {
      this.$refs.openModal.show();
      this.addPath();
    },
    loadStates() {
      this.$api
        .get("/state/getDropdownOptions")
        .then((response) => {
          this.optionsState = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    deletePath(row) {
      // console.log(row);
      let rowIndex = this.tableRows.indexOf(row);
      if (rowIndex >= 0) {
        this.tableRows.splice(rowIndex, 1);
      } else {
        row.item.active = false;
      }
      let nextSequenceNumber = 1;
      for (let item of this.getSortedList(this.items)) {
        if (item.active == true) {
          item.sequenceNumber = nextSequenceNumber;
          nextSequenceNumber++;
        }
      }
    },
    addTableRow(item) {
      this.tableRows.push(item);
    },
    addPath() {
      if (this.items.length == 0) {
        this.model = {
          active: true,
          destinationCityId: "",
          destinationCityName: "",
          destinationStateId: 0,
          destinationStateAbrev: "",
          originCityId: this.carga.originCityId,
          originCityName: this.carga.originCityName,
          originStateId: this.carga.originStateId,
          originStateAbrev: this.carga.originStateAbrev,
          nfeNumber: "",
          cteNumber: this.carga.loadingCteNumber,
          manifestNumber: this.carga.loadingManifestNumber,
          ciotNumber: this.carga.loadingCiotNumber,
          freightContract: this.carga.loadingContractNumber,
          freightCost: 0.0,
          delivered: false,
          sequenceNumber: this.getNextSequenceNumber(this.items),
        };
      } else {
        for (let item of this.getSortedList(this.items)) {
          if (item.active == true) {
            if (
              !item.sequenceNumber ||
              item.sequenceNumber == null ||
              item.sequenceNumber <= 0
            ) {
              item.sequenceNumber = this.getNextSequenceNumber(this.items);
            }
          }
        }
        this.model = {
          active: true,
          destinationCityId: 0,
          destinationCityName: "",
          destinationStateId: 0,
          destinationStateAbrev: "",
          originCityId: 0,
          originCityName: "",
          originStateId: 0,
          originStateAbrev: "",
          nfeNumber: "",
          cteNumber: "",
          manifestNumber: "",
          ciotNumber: "",
          freightContract: "",
          freightCost: 0.0,
          delivered: false,
          sequenceNumber: this.getNextSequenceNumber(this.items),
        };
      }
    },
    loadTableRows() {
      this.tableRows = [];
      if (this.items) {
        if (this.items.length > 0) {
          this.items.forEach((item) => {
            this.addTableRow(item);
          });
        }
      }
      this.$forceUpdate();
    },
    getLastSequenceNumber(items) {
      let sequence = 0;
      for (let item of items) {
        if (item.active == true) {
          if (item.sequenceNumber && item.sequenceNumber != null) {
            if (item.sequenceNumber > sequence) {
              sequence = item.sequenceNumber;
            }
          }
        }
      }
      return sequence;
    },
    getNextSequenceNumber(items) {
      return this.getLastSequenceNumber(items) + 1;
    },
    getSortedList(arrayObject) {
      if (arrayObject) {
        if (arrayObject.length > 0) {
          return arrayObject
            .filter((x) => x.active == true)
            .sort((a1, a2) => a1.sequenceNumber - a2.sequenceNumber);
        }
      }
      return arrayObject;
    },
    getStatus(item) {
      // console.log(item);
      if (item.destinationCityId == 0 || item.destinationCityId == null)
        return false;
      if (item.destinationStateId == 0 || item.destinationStateId == null)
        return false;
      if (item.originCityId == 0 || item.originCityId == null) return false;
      if (item.originStateId == 0 || item.originStateId == null) return false;
      return true;
    },
    modalOk(item) {
      // console.log(item);
      // console.log('modalOk');
      this.items.push(item);
      this.addTableRow(item);
      this.$forceUpdate();
    },
  },
  watch: {
    items() {
      this.loadTableRows();
    },
  },
};
</script>
<style scoped>
.deletePath {
  margin-left: 50% !important;
  margin-top: -51px !important;
}
.newPath {
  margin-top: -45px !important;
}
.right {
  text-align: right;
  width: 100%;
}
.icone {
  margin-top: -55px !important;
}
.btn_edit {
  margin-top: 20%;
}
.delivered {
  padding: 20%;
}
</style>